import { ReactComponent as Logo } from '../../assets/icons/statistic.svg'

const Statistic = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Statistic
